import { LoginPage } from '@src/pages/public/Login';
import { UnauthorizedPage } from '@src/pages/public/Unauthorized';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Loader } from '@src/shared/ui/components/Loader';
import { Router } from '@uhg-abyss/web/ui/Router';
import React from 'react';

/**
 * Public
 *
 * This component serves as a router for the public routes.
 *
 * @returns {Element}
 * @constructor
 */
export function Public() {
  return (
    <ErrorHandler location="src/app/components/Router/components/Public.jsx">
      <Router.Routes>
        <Router.Route element={<Loader height="100vh" width="100vh" />} path="/*" />
        <Router.Route element={<LoginPage />} path="/login" />
        <Router.Route element={<UnauthorizedPage />} path="/unauthorized" />
      </Router.Routes>
    </ErrorHandler>
  );
}
